import React, { useEffect, useState } from 'react';
import { AddRegular, EditRegular } from '@fluentui/react-icons';
import { Button, Caption1Strong, mergeClasses } from '@fluentui/react-components';
import { IColor } from '@fluentui/react';
import { useStyles } from './style';
import {
  IColorAddButton,
  IBrandColors,
} from './type';
import AdsColorPickerTooltip from './Tooltip';
import { useHandleCloseColorPicker } from './hooks';

const defaultState = {
  Name: '',
  HexCode: '',
};
export const BrandColors = ({
  showEditBtn: enableEditBtn, // this will show edit icon on hover and on false will select color
  showTooltipOnSelect, //  this will open tooltip on select color and hide edit icon
  defaultSelected,
  isDuplicate,
  i18n,
  colorData: color,
  hideCaption = false,
  onDelete,
  updateColor,
  palletteBoxSize,
  paletteColorSize,
  onTooltipVisibilityChange,
}: IBrandColors) => {
  const [showEditBtn, setShowEditBtn] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [colorData, setColorData] = useState(color);
  useEffect(() => {
    if (isDuplicate) {
      setColorData(color);
    }
  }, [color, isDuplicate]);
  const classes = useStyles();
  const {
    popupRef,
  } = useHandleCloseColorPicker({
    isSelected,
    colorData,
    setIsSelected,
    updateColor,
  });
  const onEdit = () => {
    setIsSelected(true);
  };
  const onUpdate = (name: string, colorObj: IColor) => {
    setColorData({ Name: name, HexCode: colorObj.str });
  };
  const onMouseEnter = () => {
    enableEditBtn && setShowEditBtn(true);
  };
  const onMouseLeave = () => {
    setShowEditBtn(false);
  };
  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onMouseEnter();
    }
  };
  const onSelectColor = () => {
    if (showTooltipOnSelect) {
      setIsSelected(true);
      return;
    }
    if (!enableEditBtn) {
      updateColor(colorData.Name, { hex: colorData.HexCode, str: colorData.HexCode } as IColor);
    }
  };
  if (!colorData) return null;
  const selectedColorStyle = { boxShadow: 'inset 0 0 0 var(--strokeWidthThicker) var(--colorBrandStroke1), inset 0 0 0 5px var(--colorStrokeFocus1)' };
  return (
    <AdsColorPickerTooltip
      colorData={colorData}
      updateColor={onUpdate}
      onDelete={onDelete}
      i18n={i18n}
      isColorSelected={isSelected}
      onTooltipVisibilityChange={onTooltipVisibilityChange}
    >
      <div ref={popupRef} className={classes.flexColumn}>
        <div
          className={mergeClasses(classes.paletteBox, classes.flex)}
          style={{
            width: palletteBoxSize || '62px',
            height: palletteBoxSize || '62px',
          }}
        >
          <div
            className={mergeClasses(classes.paletteColor, classes.flex, 'color-box')}
            style={{
              width: paletteColorSize || '55px',
              height: paletteColorSize || '55px',
              backgroundColor: colorData.HexCode,
              ...(isSelected || defaultSelected ? selectedColorStyle : {}),
            }}
            onClick={onSelectColor}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            tabIndex={0}
            onKeyDown={onKeyDown}
            role="button"
          >
            {showEditBtn && !showTooltipOnSelect && (
              <Button
                icon={<EditRegular color={colorData.HexCode} />}
                data-colorid={colorData.Name}
                size="medium"
                style={isSelected ? { visibility: 'hidden' } : {}}
                className={mergeClasses('edit_btn', classes.editBtn)}
                onClick={onEdit}
              />
            )}
          </div>
        </div>
        {!hideCaption && <Caption1Strong className="color-hexcode">{colorData.HexCode}</Caption1Strong>}
      </div>

    </AdsColorPickerTooltip>
  );
};

export const ColorAddButton = ({
  updateColor,
  i18n,
  isDuplicate,
  totalColors,
  palletteBoxSize,
  paletteColorSize,
}: IColorAddButton) => {
  const classes = useStyles();
  const [isSelected, setIsSelected] = useState(false);
  const [colorData, setColorData] = useState(defaultState);
  useEffect(() => {
    setColorData(defaultState);
  }, [totalColors, isDuplicate]);
  const {
    popupRef,
  } = useHandleCloseColorPicker({
    isSelected,
    colorData,
    setIsSelected,
    updateColor,
  });
  const onAdd = () => {
    setIsSelected(true);
  };
  const onUpdate = (name: string, colorObj: IColor) => {
    setColorData({ Name: name, HexCode: colorObj.str });
  };

  return (
    <AdsColorPickerTooltip
      updateColor={onUpdate}
      isColorSelected={isSelected}
      i18n={i18n}
      colorData={colorData}
    >
      <div
        ref={popupRef}
        className={mergeClasses(classes.flex)}
        style={{
          width: palletteBoxSize || '62px',
          height: palletteBoxSize || '62px',
        }}
      >
        {colorData && colorData.HexCode ? <div
          className={mergeClasses(classes.paletteColor, classes.flex)}
          style={{
            width: paletteColorSize || '55px',
            height: paletteColorSize || '55px',
            backgroundColor: colorData.HexCode,
          }}
          role="button"
        /> : <Button
          style={{
            width: paletteColorSize || '55px',
            height: paletteColorSize || '55px',
          }}
          icon={<AddRegular color="#0078D4" />}
          key="add_color"
          onClick={onAdd}
          className={mergeClasses(classes.paletteAddColor, classes.newColor, 'add_button')}
        />
        }
      </div>
    </AdsColorPickerTooltip>
  );
};
